module.exports = __webpack_public_path__ + "img/ven-talentpool-nodata.71eabc74.svg";